import api from '@/services/api/config';

const path = 'v1/asset-standard/standort';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
  create: (standort) => api.post(path, standort),
  rename: (id, standort) => api.patch(`${path}/${id}/name`, standort),
  delete: (id) => api.delete(`${path}/${id}`),
};
